
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 200 141","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.17 32.738c-5.527 1.992-5.566 5.215-.078 7.187L92.06 70.082c5.468 1.972 4.316 1.972 9.843-.02l46.075-15.586L96.494 33.93a4.399 4.399 0 01-2.46-5.722l.077-.196c.899-2.246 3.477-3.34 5.723-2.441l60.938 24.57c.351.137.527.293.605.45 8.027 6.21 10.371 15.78 10.684 26.503a9.616 9.616 0 00-4.551 8.184 9.598 9.598 0 004.004 7.812c-1.387 20-3.516 40.118 14.14 47.696 4.844-1.602 8.067-3.223 14.317-8.047-12.637-15.04-16.934-27.734-18.438-38.828a9.63 9.63 0 005.332-8.633c0-4.102-2.578-7.617-6.21-9.004-.118-10.937-.743-20.371-10.118-29.434l21.192-7.168c5.527-1.992 5.566-5.214.078-7.187l-89.14-30.176c-5.49-1.972-4.317-1.972-9.845.04L4.17 32.737m97.89 48.984c-5.527 1.992-4.413 2.012-9.882.02L34.854 62.074v31.23c0 2.676 2.07 5.43 4.746 7.637 36.093 19.512 80.976 19.707 113.437 1.816 1.836-.683 3.125-2.851 3.867-5.078-2.265-2.597-3.593-6.074-3.593-9.902 0-4.238 1.601-8.066 4.53-10.742v-14.18l-55.78 18.867","fill-rule":"nonzero"}})])
          )
        }
      }
    